import React from 'react';
import ButtonGroup from '@atlaskit/button/button-group';
import Spinner from '@atlaskit/spinner';
import { ActionsContainer, Container, Description, Header, Image, SpinnerContainer } from '../styled';

const EmptyState = ({
  description,
  header,
  imageHeight,
  imageUrl,
  imageWidth,
  isLoading,
  maxImageHeight = 160,
  maxImageWidth = 160,
  primaryAction,
  renderImage,
  secondaryAction,
  size = 'wide',
  tertiaryAction
}) => {
  const actionsContainer = primaryAction || secondaryAction || isLoading ? /*#__PURE__*/React.createElement(ActionsContainer, null, /*#__PURE__*/React.createElement(ButtonGroup, null, secondaryAction, primaryAction), /*#__PURE__*/React.createElement(SpinnerContainer, null, isLoading && /*#__PURE__*/React.createElement(Spinner, null))) : null;
  return /*#__PURE__*/React.createElement(Container, {
    size: size
  }, imageUrl ? /*#__PURE__*/React.createElement(Image, {
    alt: "",
    role: "presentation",
    src: imageUrl,
    maxWidth: maxImageWidth,
    maxHeight: maxImageHeight,
    width: imageWidth,
    height: imageHeight
  }) : renderImage && renderImage({
    maxImageWidth,
    maxImageHeight,
    imageWidth,
    imageHeight
  }), /*#__PURE__*/React.createElement(Header, null, header), description && /*#__PURE__*/React.createElement(Description, null, description), actionsContainer, tertiaryAction);
};

export default EmptyState;